import React from "react";
import {Field, reduxForm} from "redux-form";
import { renderTextField } from "../helpers/formFields";
import Button from '@mui/material/Button';

class PasswordForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    } 

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Field 
                     name="password"
                     id="password"
                     component={renderTextField} 
                     label="Current Password"
                     type="password"
                     autoComplete="current-password"
                     // autoFocus
                     margin="normal"
                     required
                     fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field 
                     name="password_new"
                     id="password_new"
                     component={renderTextField} 
                     label="New Password"
                     type="password"
                     // autoFocus
                     margin="normal"
                     required
                     fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field 
                     name="password_confirm"
                     id="password_confirm"
                     component={renderTextField} 
                     label="Confirm Password"
                     type="password"
                     // autoFocus
                     margin="normal"
                     required
                     fullWidth
                    InputLabelProps={{ shrink: true }}
                />                                 
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Save
                </Button>
            </form>
        )
    }    

}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.password) {
        errors.password = 'You did not enter a password';
    }

    if (!formValues.password_new) {
        errors.password_new = 'You did not enter a new password';
    }    

    if (formValues.password_confirm) {
        if (formValues.password_new !== formValues.password_confirm) {
            errors.password_confirm = 'You must enter the same password';
        }
    }    

    return errors;
};

export default reduxForm({
    form: 'passwordForm',
    validate: validate
})(PasswordForm);